<div class="add-container">
    <h1 class="add-title">Adaugă secțiune publică</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="id_directie" (openedChange)="onDirectieSelectClosed()"
                        (selectionChange)="onDirectieChange($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_directie'].valid && form.controls['id_directie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="id_compartiment" (openedChange)="onCompartimentSelectClosed()">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="compartimenteControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                        <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie Documente</mat-label>
                    <mat-select formControlName="id_group">
                        <mat-option *ngFor="let categorie of categoriiDocumente" [value]="categorie.id">
                            {{ categorie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_group'].valid && form.controls['id_group'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Content</mat-label>
                    <input type="text" matInput formControlName="content" />
                    <mat-error *ngIf="!form.controls['content'].valid && form.controls['content'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <input type="text" matInput formControlName="observations" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>